// extracted by mini-css-extract-plugin
export default {"container":"Statistics_container__nF5ZB"};